import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/InputLabel": InputLabel, "@mui/material/MenuItem": MenuItem, "@mui/material/FormHelperText": FormHelperText, "@mui/material/FormControl": FormControl, "@mui/material/Select": Select } } });
export default ClientProvider;
